module.exports = __webpack_public_path__ + "img/goods08.57f760ea.jpg";